import React, { FC, useState } from 'react';
import { Asset, Button, CalendarMinimalIcon, Modal } from '@clearcover/atlas';

import { PaymentScheduleModalContent } from './PaymentScheduleModalContent';
import { PaymentScheduleModalProps } from './types';
import styles from './styles.module.css';

const DEFAULT_BUTTON_TEXT = 'View Payment Schedule';

export const PaymentScheduleModal: FC<PaymentScheduleModalProps> = ({
  buttonText = DEFAULT_BUTTON_TEXT,
  currentPlan,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        className={styles.paymentScheduleButton}
        block
        link
        onClick={() => setOpen(true)}
        data-testid="view-payment-schedule-button"
      >
        <Asset
          icon={CalendarMinimalIcon}
          description="view-payment-schedule-calendar-icon"
          height={20}
          width={20}
        />
        {buttonText}
      </Button>
      <Modal
        controlled={true}
        open={open}
        variant="normal"
        handleClose={() => setOpen(false)}
      >
        {closeModal => (
          <PaymentScheduleModalContent
            paymentPlan={currentPlan}
            closeModal={closeModal}
          />
        )}
      </Modal>
    </>
  );
};
